import { jsx as _jsx } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import { Widget } from './Widget';
export function TilesWidgetPlaceholder(props) {
    function tile(widget, placement, index) {
        return (_jsx(Widget, { id: widget.id, type: placement.size || Common.WidgetSize.Button, placementManager: props.placementManager, placeholderType: Common.WidgetPlaceholderType.Tiles, placement: placement, allowFallback: true, tileSize: Components.TileSize.ExtraBig }, index));
    }
    return (_jsx(Components.Tiles, { children: props.widgets.map(([widget, placement], index) => tile(widget, placement, index)) }));
}
